const questions = [
  {
    id: 1,
    question: "The experiment failed; ___, the data was still valuable.",
    options: ["however", "because", "therefore"],
    answer: "however",
    concept: "contrast_marker",
    skill: "logical_contrast",
    explanation: "'However' is used to introduce a contrast with the previous idea."
  },
  {
    id: 2,
    question: "He missed the deadline; ___, the contract was canceled.",
    options: ["moreover", "therefore", "although"],
    answer: "therefore",
    concept: "cause_effect_marker",
    skill: "logical_result",
    explanation: "'Therefore' is used to show a result or consequence."
  },
  {
    id: 3,
    question: "She is highly qualified; ___, she has extensive experience in the field.",
    options: ["however", "moreover", "despite"],
    answer: "moreover",
    concept: "addition_marker",
    skill: "idea_expansion",
    explanation: "'Moreover' is used to add supporting information."
  },
  {
    id: 4,
    question: "___ being inexperienced, he performed excellently.",
    options: ["Although", "Despite", "However"],
    answer: "Despite",
    concept: "preposition_of_contrast",
    skill: "contrast_structure",
    explanation: "'Despite' is followed by a noun or gerund to show contrast."
  },
  {
    id: 5,
    question: "The proposal was rejected ___ its innovative ideas.",
    options: ["although", "despite", "therefore"],
    answer: "despite",
    concept: "despite_vs_although",
    skill: "connector_accuracy",
    explanation: "'Despite' is used before nouns, not full clauses."
  }
];

export default questions;


